module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.be142e6.woff";